import { ConsentsDto } from "src/app/api/smart-pensjon-rest-api/models";
import { ConsentModel } from "../../models/consent.model";
import { MockScenario } from "../mock-scenario";

/**
 * With all consents every consent is answered yes. Without them none is answered yet (null), so the onboarding
 * consents step opens with nothing selected. The group and marketing dialog is never due, as before.
 */
export const generateMockConsents = (scenario: MockScenario): { payload: ConsentModel & ConsentsDto } => {
  const answer = scenario.hasAllConsents ? true : null;

  return {
    payload: {
      hasNavConsent: answer,
      hasOfaConsent: answer,
      hasCustomerSuppliedDataConsent: answer,
      hasNorskPensjonConsent: answer,
      hasGroupConsent: answer,
      hasElectronicSolicitationConsent: answer,
      hasSocialMediaSolicitationConsent: answer,
      groupAndMarketingConsentDue: false,
    },
  };
};
